import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(Vuex)
Vue.use(VueResource)

export default new Vuex.Store({
  state : {
    users: [],
    suppliers: [],
    allowedTakeStatuses: [],
    allowedPrepareStatuses: [],
    allowedMoveStatuses: [],
    allowedUpdateStatuses: [],
    allowedTakeTypes: [],
    allowedMoveTypes: [],
    allowedUpdateTypes: [],
    warehouses: [],
    objectTypes: [],
    meals: [],
    materials: [],
    objects: {},
    currentUser: null,
  },
  getters: {
    suppliersCount: state => state.suppliers.length,
    usersCount: state => state.users.length,
    allowedTakeStatusesCount: state => state.allowedTakeStatuses.length,
    allowedPrepareStatusesCount: state => state.allowedPrepareStatuses.length,
    allowedMoveStatusesCount: state => state.allowedMoveStatuses.length,
    allowedTakeTypesCount: state => state.allowedTakeTypes.length,
    allowedMoveTypesCount: state => state.allowedMoveTypes.length,
    allowedUpdateTypesCount: state => state.allowedUpdateTypes.length,
    warehousesCount: state => state.warehouses.length,
    objectTypesCount: state => state.objectTypes.length,
    objectsCount: state => Object.keys(state.objects).length,
    mealsCount: state => state.meals.length,
    materialsCount: state => state.materials.length,
  },
  actions: {
    fetchUsers({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.usersCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_get_employees', { context: 'dropdown' })).then(response => {
          commit('setUsers', response.data)
          resolve()
        })
      })
    },
    fetchSuppliers({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.suppliersCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_get_suppliers_active', { context: 'dropdown' })).then(response => {
          commit('setSuppliers', response.data)
          resolve()
        })
      })
    },
    fetchAllowedTakeStatuses({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.allowedTakeStatusesCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_warehouseman_allowed_take_statuses')).then(response => {
          commit('setAllowedTakeStatuses', response.data)
          resolve()
        })
      })
    },
    fetchAllowedPrepareStatuses({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.allowedPrepareStatusesCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_warehouseman_allowed_prepare_statuses')).then(response => {
          commit('setAllowedPrepareStatuses', response.data)
          resolve()
        })
      })
    },
    fetchAllowedMoveStatuses({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.allowedMoveStatusesCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_warehouseman_allowed_move_statuses')).then(response => {
          commit('setAllowedMoveStatuses', response.data)
          resolve()
        })
      })
    },
    fetchAllowedUpdateStatuses({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.allowedMoveStatusesCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_warehouseman_allowed_update_statuses')).then(response => {
          commit('setAllowedUpdateStatuses', response.data)
          resolve()
        })
      })
    },
    fetchAllowedTakeTypes({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.allowedTakeTypesCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_warehouseman_allowed_take_move_types')).then(response => {
          commit('setAllowedTakeTypes', response.data)
          resolve()
        })

      })
    },
    fetchAllowedMoveTypes({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.allowedMoveTypesCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_warehouseman_allowed_move_move_types')).then(response => {
          commit('setAllowedMoveTypes', response.data)
          resolve()
        })

      })
    },
    fetchAllowedUpdateTypes({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.allowedMoveTypesCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_warehouseman_allowed_update_move_types')).then(response => {
          commit('setAllowedUpdateTypes', response.data)
          resolve()
        })

      })
    },

    fetchCurrentUser({ commit, state }) {
      return new Promise((resolve) => {
        if (state.currentUser) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_me_employee', { context: 'dropdown' })).then(response => {
          commit('setCurrentUser', response.data)
          resolve()
        })
      })
    },
    fetchWarehouses({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.warehousesCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_get_warehouses', { context: 'dropdown' })).then(response => {
          commit('setWarehouses', response.data)
          resolve()
        })

      })
    },
    fetchObjectTypes({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.objectTypesCount > 0) {
          resolve()
          return
        }

        Vue.http.get(Routing.generate('api_get_warehouse_shifts_object_type', { context: 'dropdown' })).then(response => {
          commit('setObjectTypes', response.data)
          resolve()
        })
      }
      )
    },
    fetchObjects({ commit, state }, { warehouse }) {
      let promises = state.objectTypes.map(type => {
        return new Promise((resolve) => {
          let url = Routing.generate('api_get_warehouse_shifts_available_objects_by_type_and_warehouse', {
            type,
            warehouse: warehouse.id,
            context: 'dropdown'
          })

          Vue.http.get(url).then(response => {
            commit('setObjects', {
              'objects'       : response.data,
              'objectType'    : type,
            })
            resolve()
          })
        })
      })

      return Promise.all(promises)
    },
    fetchMeals({ commit, state, getters }) {
      if (!state.objects.serving_component || !state.objects.serving_final) {
        return Promise.resolve()
      }

      return new Promise((resolve) => {
        if (getters.mealsCount > 0) {
          resolve()
          return
        }

        let finalMeals = {}

        state.objects.serving_final.forEach(serving => {
          finalMeals[serving.mealname] = {
            'id' : serving.mealid,
            'name' : serving.mealname,
            'nameForSelect' : `#${serving.mealid} ${serving.mealname}`
          }
        })

        commit('setMeals', Object.values(finalMeals))
        resolve()
      })
    },
    fetchMaterials({ commit, getters }) {
      return new Promise((resolve) => {
        if (getters.materialsCount > 0) {
          resolve()
          return
        }

        let url = Routing.generate('api_get_materials', { context: 'dropdown' })
        Vue.http.get(url).then(response => {
          commit('setMaterials', response.data)
          resolve()
        })
      })
    },
  },

  mutations: {
    setUsers(state, users) {
      state.users = users
    },
    setAllowedTakeStatuses(state, statuses) {
      state.allowedTakeStatuses = statuses
    },
    setAllowedPrepareStatuses(state, statuses) {
      state.allowedPrepareStatuses = statuses
    },
    setAllowedMoveStatuses(state, statuses) {
      state.allowedMoveStatuses = statuses
    },
    setAllowedUpdateStatuses(state, statuses) {
      state.allowedUpdateStatuses = statuses
    },
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser
    },
    setAllowedTakeTypes(state, types) {
      state.allowedTakeTypes = types
    },
    setAllowedMoveTypes(state, types) {
      state.allowedMoveTypes = types
    },
    setAllowedUpdateTypes(state, types) {
      state.allowedUpdateTypes = types
    },
    setSuppliers(state, suppliers) {
      state.suppliers = suppliers
    },
    setWarehouses(state, warehouses) {
      state.warehouses = warehouses
    },
    setObjectTypes(state, objectTypes) {
      state.objectTypes = objectTypes
    },
    setMeals(state, meals) {
      state.meals = meals
    },
    setObjects(state, { objectType, objects }) {
      state.objects[objectType] = objects
    },
    setMaterials(state, materials) {
      state.materials = materials
    },
  }

})
